import React, { useContext, useRef, useState } from 'react'
import { Form, Button, Col, Row, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios'
import ToastManager from './ToastManager';
import GlobalContext from './GlobalContext';

function CadastroUsuarios(props) {

    const [formData, setFormData] = useState({
        displayName: '',
        phoneNumber: '',
        email: '',
        confirmEmail: '',
        sendPassword: true
    });

    const { globalData, setGlobalData } = useContext(GlobalContext);

    const [validated, setValidated] = useState(false);
    const [registerSpinner, setRegisterSpinner] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [formVisible, setFormVisible] = useState(false)
    const formRef = useRef(null);


    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name == 'sendPassword') {
            value = e.target.checked;
        }
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
        } else {
            if (formData.email !== formData.confirmEmail) {
                setErrorMessage('Emails diferentes');
            } else {
                setErrorMessage('');
                // Submit form data
                setRegisterSpinner(true);

                axios.post(`${globalData.apiHost}/newuser`, formData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_BACKEND_SECRET
                    }
                }).then((response) => {
                    console.log(response.data)
                    props.handleShowToast('Usuário criado com sucesso', `Um usuário foi criado com o email: ${formData.email}`)
                    props.refreshListaUsuarios();

                    console.log(formRef.current)
                    formRef.current.reset()
                    setRegisterSpinner(false);

                    setFormData({
                        displayName: '',
                        phoneNumber: '',
                        email: '',
                        confirmEmail: '',
                        sendPassword: true
                    })
                    setFormVisible(false)
                }).catch((error) => {
                    setRegisterSpinner(false);
                    console.log(error)

                })
            }
        }
    };

    return <>
        <h4 className='d-flex align-items-center'>
            Usuários
            {
                !formVisible &&
                <Button onClick={() => setFormVisible(true)} className='ms-3 btn-sm'>
                   <i className="bi bi-plus-circle" /> Novo usuário
                </Button>
            }
        </h4>
        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

        {
            formVisible &&
            <Form noValidate validated={validated} onSubmit={handleSubmit} ref={formRef}>
                <Row className="mb-3">
                    <Form.Group as={Col} md="6" controlId="name">
                        <Form.Label>Nome</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Nome do usuário"
                            name="displayName"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="phone">
                        <Form.Label>Telefone</Form.Label>
                        <Form.Control
                            //required
                            type="text"
                            placeholder="Número de telefone"
                            name="phoneNumber"
                            value={formData.phone}
                            onChange={handleChange}
                            isInvalid={validated && !formData.phone}
                        />
                        <Form.Control.Feedback type="invalid">
                            Insira um número de telefone.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>

                <Row className="mb-3">
                    <Form.Group as={Col} md="6" controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            required
                            type="email"
                            placeholder="Endereço de email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            isInvalid={validated && !formData.email}
                        />
                        <Form.Control.Feedback type="invalid">
                            Insira um email válido.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="confirmEmail">
                        <Form.Label>Confirmar endereço de Email</Form.Label>
                        <Form.Control
                            required
                            type="email"
                            placeholder="Confirme seu email"
                            name="confirmEmail"
                            value={formData.confirmEmail}
                            onChange={handleChange}
                            isInvalid={validated && !formData.confirmEmail}
                        />
                        <Form.Control.Feedback type="invalid">
                            Por favor confirme seu email.
                        </Form.Control.Feedback>
                    </Form.Group>


                </Row>

                {!registerSpinner &&
                    <div className='d-flex align-items-center justify-content-start'>
                        <Button variant="primary" type="submit" className='me-3'>
                            Registrar
                        </Button>
                        <Form.Check
                            type="checkbox"
                            id="custom-switch"
                            name='sendPassword'
                            label="Enviar senha por email"
                            value={formData.sendPassword}
                            onChange={handleChange}
                        />
                    </div>
                }
                {registerSpinner &&
                    <Spinner animation="border" role="status" className='ms-5'>
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                }

            </Form>
        }
    </>
}

export default CadastroUsuarios